// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* For confirmation dialog */
.alert-title {
    color: red;
    font-weight: bold;
    font-size: 1.3em;
}

.alert-title-black {
    color: black;
    font-weight: bold;
    font-size: 1.3em;
}

.confirmation-text {
    font-size: 1.4rem;
    list-style-type: none;
    padding: 0; /* Remove padding */
    margin: 0; /* Remove margins */
    color:black;
}

.alert-prompt-black {
    color: black;
    font-size: 1.5em;
}

.alert-prompt-red {
    color: red;
    font-size: 1.5em;
}

.w-90 {
    width: 90% !important;
}

.w-95 {
    width: 95% !important;
}





/* used for showing selected devices for mass certification */
.mass-certificaton-selected , .mass-certificaton-selected .form-control {
  background-color:rgb(243, 238, 197) ;
  background-clip: content-box;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,UAAU,EAAE,mBAAmB;IAC/B,SAAS,EAAE,mBAAmB;IAC9B,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;;;;;AAMA,6DAA6D;AAC7D;EACE,oCAAoC;EACpC,4BAA4B;AAC9B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* For confirmation dialog */\n.alert-title {\n    color: red;\n    font-weight: bold;\n    font-size: 1.3em;\n}\n\n.alert-title-black {\n    color: black;\n    font-weight: bold;\n    font-size: 1.3em;\n}\n\n.confirmation-text {\n    font-size: 1.4rem;\n    list-style-type: none;\n    padding: 0; /* Remove padding */\n    margin: 0; /* Remove margins */\n    color:black;\n}\n\n.alert-prompt-black {\n    color: black;\n    font-size: 1.5em;\n}\n\n.alert-prompt-red {\n    color: red;\n    font-size: 1.5em;\n}\n\n.w-90 {\n    width: 90% !important;\n}\n\n.w-95 {\n    width: 95% !important;\n}\n\n\n\n\n\n/* used for showing selected devices for mass certification */\n.mass-certificaton-selected , .mass-certificaton-selected .form-control {\n  background-color:rgb(243, 238, 197) ;\n  background-clip: content-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
